export default (axios) => async (id, excursionData, oauthSignature) => {
  const url = `/v2/excursions/${id}/sync`;

  const params = {
    'oauth-signature': oauthSignature
  };

  const { name, type, startDate, endDate, staffCount, studentCount, riskCategories, jurisdiction } =
    excursionData;
  const { transports, venues, foods, accommodations, activities } = riskCategories;

  const payload = {
    excursionName: name,
    excursionType: type,
    excursionStartDate: startDate,
    excursionEndDate: endDate,
    noOfStaff: staffCount,
    noOfStudents: studentCount,
    transports,
    venues,
    foods,
    accommodations,
    activities,
    jurisdiction
  };

  const axiosConfig = {
    method: 'PUT',
    url,
    params,
    data: payload
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
